'use client';

import React from 'react';

export default function NotFound() {
  return (
    <div className="flex h-screen max-h-[80vh] items-center justify-center">
      <div className="flex flex-col items-center justify-center gap-4 text-center">
        <h1 className="typography-page-title text-semantic-text-primary">404</h1>
        <p className="typography-body text-semantic-text-secondary">Page not found</p>
      </div>
    </div>
  );
}
